import { AppMenu } from '@ghq-abi/design-system';
import { Skeleton } from '@ghq-abi/design-system-v2';

export function MenuSkeleton() {
  return (
    <AppMenu open={false}>
      <AppMenu.Trigger asChild>
        <AppMenu.Bar openMenu={() => {}} openMenuDelay={300}>
          <AppMenu.Header css={{ p: 0 }}>
            <div style={{ padding: '12px 8px' }}>
              <Skeleton className="h-6 w-24 rounded" />
            </div>
          </AppMenu.Header>

          <AppMenu.MenuList>
            {Array.from({ length: 4 }, (_, index) => (
              <div key={index} style={{ padding: '8px', marginBottom: '4px' }}>
                <Skeleton className="h-8 w-full rounded" />
              </div>
            ))}
          </AppMenu.MenuList>

          <AppMenu.Footer>
            <div style={{ padding: '12px 8px' }}>
              <Skeleton className="h-6 w-32 rounded" />
            </div>
          </AppMenu.Footer>
        </AppMenu.Bar>
      </AppMenu.Trigger>
    </AppMenu>
  );
}
